export const rules ={
  package_name: [
    { required: true, message: "投资包名称!", trigger: "change" },
  ],
  total_value: [
    { required: true, message: "总金额", trigger: "blur" },
  ],
  total_shares: [
    { required: true, message: "总份额数", trigger: "change" },
  ],
  min_investment_shares: [
    { required: true, message: "最低认领", trigger: "blur" },
  ],
  divi_rate:{
    required: true,
    message: "分红比例",
    trigger: "blur"
  },
  venue_count:{
    required: true,
    message: "门店数量",
    trigger: "blur"
  }
     
    }
    


